// Scheda prodotto Looniva: consegna stimata e aggiunta delle federe.
(() => {
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      const wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  };
  window.lvDelivery = (from, min, max) => ({ from: addBusinessDays(from, min), to: addBusinessDays(from, max) });

  const fmt = (d) => d.toLocaleDateString(document.documentElement.lang || 'it', { day: 'numeric', month: 'long' });
  document.querySelectorAll('[data-lv-delivery]').forEach((el) => {
    const r = window.lvDelivery(new Date(), Number(el.dataset.min), Number(el.dataset.max));
    el.textContent = el.dataset.label.replace('{from}', fmt(r.from)).replace('{to}', fmt(r.to));
  });

  // Aggiunta federe: Haven invia il modulo prodotto principale con un submit
  // su form[action*="/cart/add"] (component-product-form in assets/theme.js,
  // handleFormSubmit), che fa preventDefault e il fetch lui stesso; qui ci si
  // limita a leggere lo stato della casella alla cattura del submit. A fine
  // giro Haven invia sempre "theme-cart:updated": shouldOpenCart true solo se
  // il prodotto principale e' stato aggiunto (il carrello rapido e' attivo su
  // questo tema); se fallisce (shouldOpenCart false, nessun carrello rapido
  // aperto) le federe non vengono aggiunte. Se l'aggiunta delle federe stessa
  // fallisce, l'errore passa dal banner del carrello rapido di Haven
  // (detail.error/productTitle), come fa gia' il suggerimento in
  // assets/looniva-cart.js.
  let pending = false;
  document.addEventListener('submit', (e) => {
    const box = document.querySelector('[data-lv-addon-variant]');
    if (box && box.checked && e.target.closest('form[action*="/cart/add"]')) pending = true;
  }, true);
  document.addEventListener('theme-cart:updated', async (e) => {
    if (!pending || e.detail?.lvAddon) return;
    pending = false;
    if (e.detail?.shouldOpenCart !== true) return;
    const box = document.querySelector('[data-lv-addon-variant]');
    if (!box || !box.checked) return;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(box.dataset.lvAddonVariant), quantity: 1 }] }),
    });
    const detail = { shouldOpenCart: false, lvAddon: true };
    if (!res.ok) { const j = await res.json().catch(() => ({})); detail.error = j.description || j.message || 'Errore'; detail.productTitle = box.closest('.lv-addon')?.textContent.trim(); }
    document.dispatchEvent(new CustomEvent('theme-cart:updated', { detail }));
  });
})();

// Galleria per colore (Task 2, piano 2026-10-11-looniva-direzione-a.md).
// Sui prodotti con il selettore colore dei set (#lnv-pc-root,
// snippets/looniva-color-block.liquid) mostra solo le slide del colore
// scelto piu' quelle senza colore (attributo data-lv-colore scritto da
// snippets/product-media-gallery-item.liquid dal suffisso dell'alt, vedi
// snippets/product-media-gallery.liquid). Se il colore scelto non ha slide,
// mostra tutte (sicurezza). Il selettore colore non espone un evento
// dedicato alla scelta: lo stato e' lo swatch con classe "active" dentro
// #lnv-pc-swatches (aggiornata sia al click sia quando una taglia rende
// disponibile il colore scelto), quindi l'aggancio e' un MutationObserver
// su quella sottoalbero, senza toccare looniva-color-block.liquid. Sui
// prodotti a colore singolo #lnv-pc-root non esiste: niente filtro, restano
// solo le schede gia' tolte lato server.
(() => {
  if (typeof document.getElementById !== 'function' || typeof document.querySelectorAll !== 'function') return;
  const pcRoot = document.getElementById('lnv-pc-root');
  if (!pcRoot || !window.lvGallery) return;

  const reduceMotion = typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MAX_DOTS = 8;

  const currentColorNorm = () => {
    const active = document.querySelector('#lnv-pc-swatches .lnv-pc-swatch.active');
    if (!active) return '';
    return window.lvGallery.pickerIdToAltColor(active.dataset.color);
  };

  const galleryFilters = [];

  document.querySelectorAll('.product-media-gallery').forEach((gallery) => {
    const sliderEl = gallery.querySelector('component-slider');
    const wrapper = sliderEl
      ? sliderEl.querySelector('.slider__wrapper')
      : gallery.querySelector('.product-media-gallery__content');
    if (!wrapper) return;

    const allSlides = Array.from(wrapper.children).map((el) => ({ el, colore: el.dataset.lvColore || '' }));
    if (allSlides.length === 0) return;

    const pagination = sliderEl ? sliderEl.querySelector('.swiper-pagination') : null;
    let counter = null;

    const ensureCounter = () => {
      if (counter) return counter;
      counter = document.createElement('div');
      counter.className = 'lv-gallery-counter';
      counter.setAttribute('aria-live', 'polite');
      (sliderEl || gallery).appendChild(counter);
      return counter;
    };

    const updateCounter = (visibleCount) => {
      if (visibleCount > MAX_DOTS) {
        const c = ensureCounter();
        const active = sliderEl && sliderEl.swiper ? sliderEl.swiper.realIndex + 1 : 1;
        c.textContent = `${Math.min(Math.max(active, 1), visibleCount)} / ${visibleCount}`;
        c.hidden = false;
        if (pagination) pagination.style.display = 'none';
      } else {
        if (counter) counter.hidden = true;
        if (pagination) pagination.style.display = '';
      }
    };

    const applyFilter = (colorNorm) => {
      const visibleIdx = window.lvGallery.selectVisibleSlides(allSlides, colorNorm);
      const visibleSet = new Set(visibleIdx);
      const activeChild = wrapper.querySelector('.swiper-slide-active') || wrapper.children[0];
      const activeIndex = allSlides.findIndex((s) => s.el === activeChild);
      const activeStaysVisible = activeIndex === -1 || visibleSet.has(activeIndex);

      wrapper.innerHTML = '';
      visibleIdx.forEach((i) => wrapper.appendChild(allSlides[i].el));

      if (sliderEl && typeof sliderEl.update === 'function') {
        sliderEl.update();
        if (!activeStaysVisible) {
          if (sliderEl.swiper) {
            sliderEl.swiper.slideTo(0, reduceMotion ? 0 : undefined);
          } else if (typeof sliderEl.goToSlide === 'function') {
            sliderEl.goToSlide(0);
          }
        }
      }

      updateCounter(visibleIdx.length);
    };

    applyFilter(currentColorNorm());
    galleryFilters.push(applyFilter);

    if (sliderEl) {
      document.addEventListener('theme-slider:change', (e) => {
        if (e.detail?.element !== sliderEl) return;
        updateCounter(wrapper.children.length);
      });
    }
  });

  if (galleryFilters.length === 0) return;

  // Nessun evento dedicato alla scelta del colore (vedi commento sopra):
  // si osserva lo stato (classe "active" sullo swatch scelto) e si
  // rifiltrano tutte le gallerie della pagina quando cambia.
  const swatches = document.getElementById('lnv-pc-swatches');
  if (swatches) {
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        const colorNorm = currentColorNorm();
        galleryFilters.forEach((applyFilter) => applyFilter(colorNorm));
      });
    });
    observer.observe(swatches, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
})();
